import { EMERGENCY_ALERT } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case EMERGENCY_ALERT:
      return action.payload
    default:
      return state;
  }
}
